export default {
	logado:null,
}